import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/calendarWithClock.svg';

export const IconCalendarWithClock = createIconComponent(Icon);
